import { useEffect } from "react";

const SITE_NAME = "Vihangam Yoga Singapore";

export function useDocumentTitle(title: string | undefined): void {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
